import { render, staticRenderFns } from "./opc_form_preview.vue?vue&type=template&id=dde2ed7c&"
import script from "./opc_form_preview.vue?vue&type=script&lang=js&"
export * from "./opc_form_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports